// import SmiV2BaseApi from './SmiV2BaseApi';

export default class SmiV2BaseApi {
  serviceName = "";
  smiv2ApiEndpoint = "";
  
  constructor({ serviceName, smiv2endpoint }) {
    this.serviceName = serviceName;
    this.smiv2ApiEndpoint = smiv2endpoint;
  }
  
  getUser({ user, token }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }`, {
      headers: {
        'Content-Type': 'application/json',
        'token': token
      }
    });
  }
  
  postUser({ user, token }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': token,
        'x-rurl': window.location.href
      }
    });
  }
  
  deleteUser({ user, token }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'token': token
      }
    });
  }
  
  getBroadcast({ user, token, id, parts }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }/broadcasts/${ id }${parts ? '?parts='+parts : ''}`, {
      headers: {
        'Content-Type': 'application/json',
        'token': token
      },
    });
  }
  
  postBroadcast({ user, token, title, description, privacyStatus, framerate, resolution }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }/broadcasts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': token
      },
      body: JSON.stringify({
        title,
        description,
        privacyStatus,
        framerate,
        resolution
      })
    });
  }
  
  patchBroadcast({ user, token, broadcastId, broadcastStatus, streamId, liveChatId, chatForwardUrl }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }/broadcasts/${ broadcastId }`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'token': token
      },
      body: JSON.stringify({
        broadcastStatus,
        streamId,
        liveChatId,
        chatForwardUrl
      })
    });
  }
  
  getStream({ user, token, id, parts }) {
    return fetch(`${ this.smiv2ApiEndpoint }/v2/users/${ user }/${ this.serviceName }/streams/${ id }${parts ? '?parts='+parts : ''}`, {
      headers: {
        'Content-Type': 'application/json',
        'token': token
      },
    });
  }
}
